const IF = require( "infrontjs" );

import template from './VideoCategoryTemplate.html';

import { InAppState } from "../base/InAppState";
import { Video } from "../../model/Video";
import './../../components/general/main-menu';
import './../../components/general/header-bar';

export class VideoCategoryState extends InAppState
{
    static ROUTE = '/videos/category/:categoryId';
    static ID = 'video-category';

    async enter()
    {
        let videos = [];

        const categoryId = this.routeParams.getParam( 'categoryId' );
        const result = await this.app.api.get( '/video/' + categoryId );
        if ( result && 200 === result.status )
        {
            videos = await result.json();
        }


        this.app.container.innerHTML = this.app.view.getHtml(
            template,
            {
                title : Video.getTitleById( categoryId ),
                videos : videos
            }
        );
    }

    async exit()
    {
    }
};
